import { render } from "./App.vue?vue&type=template&id=33fc5b1f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/BinaryFlow/components/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33fc5b1f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33fc5b1f', __exports__)) {
    api.reload('33fc5b1f', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=33fc5b1f", () => {
    api.rerender('33fc5b1f', render)
  })

}


export default __exports__